import cn from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import AssetPreviewDisplay from '../assetpreviewdisplay/AssetPreviewDisplay'
import Link from '../common/util/input/Link'

function AssetDropPreview(props) {
    const asset = props['asset']
    const href = props['href']
    const soldOut = props['soldOut']
    const isPfp = props['isPfp']
    const drop = props['drop']
    const className = props['className']

    const { t } = useTranslation('common')

    const assetData = asset.immutableData

    const { collection } = drop

    let imgSource
    for (const imgSourceOption of assetData) {
        if (
            [
                'img',
                'image',
                'backimg',
                'BackingIMG',
                'backimage',
                'imgback',
                'Back',
                'img_back',
                'Back Image',
                'img back',
                'Cover',
            ].includes(imgSourceOption['key'])
        ) {
            imgSource = imgSourceOption['value'][1]
            break
        }
    }

    let videoSource
    for (const imgSourceOption of assetData) {
        if (['video', 'Video'].includes(imgSourceOption['key'])) {
            videoSource = imgSourceOption['value'][1]
            break
        }
    }

    if (drop['displayData'] && drop['displayData']['previewImg']) {
        imgSource = drop['displayData']['previewImg']
    }

    let name = asset.name

    if (drop['displayData'] && drop['displayData']['name']) {
        name = drop['displayData']['name']
    }

    const image = imgSource
        ? imgSource.includes('http')
            ? imgSource
            : `https://ipfs.hivebp.io/preview?collection=${collection.collectionName}&size=240&hash=${imgSource}`
        : ''
    const video =
        assetData['video'] && assetData['video'].length === 2
            ? assetData['video'][1].includes('http')
                ? assetData['video'][1]
                : `https://ipfs.hivebp.io/preview?collection=${collection.collectionName}&size=240&hash=${assetData['video'][1]}`
            : ''

    return (
        <div className="relative flex justify-center h-64 px-3 m-auto sm:h-80 items-center">
            {isPfp ? (
                <div
                    className={cn(
                        'text-primary text-3xl sm:text-sm lg:text-2xl font-extrabold',
                        'absolute top-4 left-4 -rotate-9',
                        'border-primary p-1 rounded-md border-4 bg-slate-900/40 z-50 text-center whitespace-nowrap',
                    )}
                >
                    {t('drops.generative_drop')}
                </div>
            ) : null}
            {soldOut && (
                <div
                    className={cn(
                        'text-red-600 text-3xl font-extrabold uppercase',
                        'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rotate-12',
                        'border-red-600 p-2 rounded-md border-4 bg-red-100/90 z-50 text-center',
                    )}
                >
                    {t('drops.sold_out')}
                </div>
            )}
            <Link href={href} className="h-full my-auto items-center flex">
                <AssetPreviewDisplay
                    asset={{
                        name: name,
                        collection: collection,
                        mutableData: null,
                        image: image,
                        backImg: null,
                        video: video,
                    }}
                    grayScale={soldOut}
                    imgClassName={cn(
                        'max-h-64 sm:max-h-80 transition transform duration-500 cursor-pointer',
                        className,
                    )}
                    useGradient={false}
                />
            </Link>
        </div>
    )
}

export default AssetDropPreview
